import { Component, Inject } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { CoreService_TOKEN } from '../../../tokens/injection-tokens';
import { ICoreService } from '../../../interfaces/core-service.interface';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { BannerAdvertisementModel } from '../../../types/banner-advertisement.model';

@Component({
    selector: 'your-banner-is-here-control',
    templateUrl: 'your-banner-is-here.control.html',
    styleUrl: './your-banner-is-here.control.scss',
    standalone: false,
})
export class YourBannerIsHereControl extends ControlBase {
    public advertisementList: BannerAdvertisementModel[] = [];
    public get showBanner(): boolean {
        return this.advertisementList.length > 0;
    }

    constructor(
        @Inject(CoreService_TOKEN)
        private coreService: ICoreService,
        protected override spinnerService: NgxSpinnerService
    ) {
        super(spinnerService);
    }

    public ngOnInit(): void {
        this.getActiveBannerAdvertisement();
    }

    public getActiveBannerAdvertisement = async (): Promise<any> => {
        return firstValueFrom(this.coreService.getActiveBannerAdvertisement())
            .then(res => {
                this.advertisementList = res.result;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
            });
    };
}
